import styled from 'styled-components';

export const StyledLightningSensor = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  box-shadow: 0px 6px 24px 0px #0000001f;
  border: 1px solid #e0e0e0;
  width: 850px;

  border-radius: 12px;
  display: flex;
  flex-direction: column;
  z-index: 10000;

  .ls-header {
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    border-bottom: 1px solid #eeeeee;
    flex-shrink: 0;
    cursor: grab;
    user-select: none;

    &:active {
      cursor: grabbing;
    }
  }

  .ls-title {
    font-size: 18px;
    font-weight: 600;
    color: #2f2f35;
  }

  .ls-close-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ls-body {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 20px 24px 30px;
    gap: 16px;
  }

  .ls-sub-title {
    font-size: 16px;
    font-weight: 600;
    color: #2f2f35;
  }

  .ls-main-contents {
    display: flex;
    gap: 10px;
  }

  .ls-detail-info {
    height: 210px;
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    border: 1px solid #dadada;
    background-color: #fffaeb;
    width: 50%;
    justify-content: center;
    align-items: center;
    position: relative;
    gap: 8px;
  }

  .ls-detail-status {
    position: absolute;
    color: #ffffff;
    top: 10px;
    left: 10px;
    background-color: #fbbf24;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 4px;
  }

  .distance-label {
    font-size: 15px;
    font-weight: 600;
    color: #2f2f35;
  }

  .distance-value {
    font-size: 15px;
    font-weight: 600;
    color: #fbbf24;
  }

  .ls-chart-info {
    width: 50%;
    border-radius: 6px;
    border: 1px solid #dadada;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 210px;
  }

  .ls-chart {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 6px 0;
  }

  .ls-chart-legend {
    display: inline;
    gap: 4px 0;
    border-top: 1px solid #f0f0f0;
    padding: 5px;
  }

  .ls-legend-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .ls-legend-dot {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .ls-legend-label {
    color: #adadad;
    font-size: 11px;
    font-weight: 700;
  }

  .ls-legend-range {
    font-weight: 700;
    color: #2f2f35;
    font-size: 11px;
  }

  .ls-legend-unit {
    font-size: 8px;
    font-weight: 700;
    color: #2f2f35;
  }

  .ls-bottom-text {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ls-bottom-text > span {
    font-size: 13px;
    font-weight: 500;
    text-align: center;
    color: #585959;
  }
`;
